import axiosInstance from "./axios.instance";


export const hasEditPermissionApi = async(userName: string): Promise<boolean> => {
  console.log('in has')
  return axiosInstance.get(`role?user=${userName}&roleId=1556`);
}